import { HttpClient } from '@angular/common/http';
import { DomainService } from './domain-service';
import { environment } from 'environments/environment';
import 'rxjs/add/operator/toPromise';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./domain-service";
import * as i3 from "@angular/common";
/**
 * Servicio de Chat. Es el unico punto que carga, alimenta y retira el widget de Aunoa.
 *
 * <p>El widget lee la global AUNOA_USER_DATA una sola vez, cuando su iframe avisa de que ha
 * cargado, y a partir de ahi ignora cualquier cambio. Por eso el payload inicial lleva solo el
 * NIF y la poliza del producto se le envia despues con aunoachat.addContext(), que si publica
 * en el iframe en el momento de la llamada.</p>
 *
 * @author Inetum
 */
var ChatService = /** @class */ (function () {
    function ChatService(http, domainService, document) {
        this.http = http;
        this.domainService = domainService;
        this.document = document;
        /** Carga en curso o ya resuelta. Mientras exista, el widget no se vuelve a inyectar. */
        this.widgetLoad = null;
    }
    /**
     * Recupera el payload cifrado ({payload, iv}) con el NIF del usuario logado y el número
     * de póliza del producto indicado, para la identificación segura en el widget de chat.
     * Si no se indica producto, el backend devuelve el payload solo con el NIF.
     *
     * @param policyNumber número de póliza del producto seleccionado (opcional).
     */
    ChatService.prototype.getChatPayload = function (policyNumber) {
        var url = this.domainService.backendUrlWithContext + '/chat/payload';
        if (policyNumber) {
            url += '/' + encodeURIComponent(policyNumber);
        }
        return this.http.get(url).toPromise();
    };
    /**
     * Carga el widget de Aunoa, una sola vez por sesión. Las llamadas siguientes devuelven la
     * misma promesa sin inyectar nada, así que se puede invocar desde cualquier pantalla sin
     * preocuparse de duplicados.
     *
     * El orden importa: AUNOA_USER_DATA tiene que estar puesta ANTES de inyectar el script,
     * porque el widget la lee al cargar su iframe y ya no vuelve a mirarla.
     */
    ChatService.prototype.ensureWidgetLoaded = function () {
        var _this = this;
        if (null !== this.widgetLoad) {
            return this.widgetLoad;
        }
        this.widgetLoad = this.getChatPayload()
            .then(function (chatData) { return _this.injectWidget(_this.toUserData(chatData)); })
            .catch(function () { return _this.injectWidget({}); });
        return this.widgetLoad;
    };
    /**
     * Envía al bot el contexto del producto elegido y abre el chat. Sustituye a la antigua
     * reasignación de AUNOA_USER_DATA, que no llegaba al bot porque el widget ya la había
     * leído: addContext() publica en el iframe en el momento de la llamada.
     *
     * @param policyNumber número de póliza del producto seleccionado.
     */
    ChatService.prototype.openChatWithContext = function (policyNumber) {
        var _this = this;
        return this.ensureWidgetLoaded()
            .then(function () { return _this.getChatPayload(policyNumber); })
            .then(function (chatData) {
            _this.addContext(_this.toUserData(chatData));
            _this.openChat();
        })
            .catch(function () {
            // Sin contexto se abre igual: el bot conserva el NIF de la carga inicial.
            _this.openChat();
        });
    };
    /**
     * Retira el widget por completo. Necesario al cerrar sesión: ni el script de Aunoa ni sus
     * nodos se limpian solos, asi que el chat del usuario anterior seguia visible —y utilizable—
     * para el siguiente que entrase en la misma pestaña.
     */
    ChatService.prototype.destroyWidget = function () {
        var doc = this.document;
        ['#aunoa-wraper', '#aunoa-overlay', 'script[src*="webchatbot.aunoa.ai"]']
            .forEach(function (selector) {
            var nodes = doc.querySelectorAll(selector);
            for (var i = 0; i < nodes.length; i++) {
                var node = nodes[i];
                if (node.parentNode) {
                    node.parentNode.removeChild(node);
                }
            }
        });
        var win = window;
        delete win.aunoachat;
        delete win.AUNOA_LOADED;
        delete win.AUNOA_USER_DATA;
        this.widgetLoad = null;
    };
    /** Da forma al dato que espera el widget a partir de la respuesta del backend. */
    ChatService.prototype.toUserData = function (chatData) {
        return {
            cipheredPayload: (chatData && chatData.payload) ? chatData.payload : '',
            iv: (chatData && chatData.iv) ? chatData.iv : ''
        };
    };
    ChatService.prototype.injectWidget = function (userData) {
        window.AUNOA_USER_DATA = userData;
        var script = this.document.createElement('script');
        script.src = "https://webchatbot.aunoa.ai/widget/widget.min.js?botid=" + environment.aunoaKey;
        this.document.body.appendChild(script);
    };
    ChatService.prototype.addContext = function (userData) {
        var aunoachat = window.aunoachat;
        if (aunoachat && typeof aunoachat.addContext === 'function') {
            aunoachat.addContext(userData);
        }
    };
    ChatService.prototype.openChat = function () {
        var aunoachat = window.aunoachat;
        if (aunoachat && typeof aunoachat.openChat === 'function') {
            aunoachat.openChat();
        }
    };
    ChatService.ngInjectableDef = i0.defineInjectable({ factory: function ChatService_Factory() { return new ChatService(i0.inject(i1.HttpClient), i0.inject(i2.DomainService), i0.inject(i3.DOCUMENT)); }, token: ChatService, providedIn: "root" });
    return ChatService;
}());
export { ChatService };
